import $ from 'jquery';
import smoothScroll from '../../vendor/smooth-scroll';
import '../../vendor/jquery.outside-events';

$('.js-toolbox').append('<span class="js-lightbox" data-target="newsletter" />');

var container = $('.newsletter');
var subscribe = $('.subscribe', container);
var prompt = $('.prompt', container);
var inputField = $('input', subscribe);
var userEmail = $('.user-email', container);
var userEmailHidden = $('#EmailAddress', container);

var lightbox = $('.js-lightbox[data-target="newsletter"]');
var cancelBtn = $('.js-cancel', container);
var closeBtn = $('.js-close', container);
var activeClass = 'js-active';
var errorClass = 'has-error';
var hiddenClass = 'hidden';

// user has submitted the first form and wants to sign up for a newsletter
subscribe.on('submit', function (e) {
  e.preventDefault();

  var isValid = checkEmailValidity(inputField);
  if (isValid) {
    userEmail.html('Email: ' + inputField.val());
    userEmailHidden.val(inputField.val());

    container.addClass(activeClass);
    lightbox.addClass(activeClass);
    smoothScroll.smoothScrollTo('.newsletter');
  }
});

container.on('clickoutside', resetAll);
cancelBtn.on('click', resetAll);
closeBtn.on('click', resetAll);

//default hide errorfields prompt
var formGroup = $('.form-group', prompt);
formGroup.find('.error').addClass(hiddenClass);
var termsConditions = $('.terms-conditions', prompt);
termsConditions.find('.error').addClass(hiddenClass);

// user has submitted the second form
prompt.on('submit', function (e) {
  if (!checkPromptValidity()) e.preventDefault();
});

function checkEmailValidity(field) {
  var formGroup = $('.form-group', subscribe);
  var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;

  // check the inputfield
  if (
    !re.test(field.val()) ||
    !field.val() ||
    field.val().indexOf('.') < 0 ||
    field.val().indexOf('@') < 0 ||
    field.val().length < 4
  ) {
    formGroup.addClass(errorClass).find('.error').removeClass(hiddenClass);
    return false;
  } else {
    formGroup.removeClass(errorClass).find('.error').addClass(hiddenClass);
    return true;
  }
}

function checkPromptValidity() {
  if (!checkEmailValidity(userEmailHidden)) {
    return false;
  }

  var formGroup = $('.form-group', prompt);
  var termsConditions = $('.terms-conditions', prompt);
  var optionSelected = false;
  var termsAgreed = false;

  if ($('input[data-set="theme"]:checked', prompt).length < 1) {
    formGroup.addClass(errorClass).find('.error').removeClass(hiddenClass);
  } else {
    formGroup.removeClass(errorClass).find('.error').addClass(hiddenClass);
    optionSelected = true;
  }

  if ($('input', termsConditions).is(':checked')) {
    termsConditions.removeClass(errorClass).find('.error').addClass(hiddenClass);
    termsAgreed = true;
  } else {
    termsConditions.addClass(errorClass).find('.error').removeClass(hiddenClass);
  }

  if (optionSelected && termsAgreed) {
    return true;
  }
}

function resetAll() {
  container.removeClass(activeClass);
  lightbox.removeClass(activeClass);
}
